// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useQuery, { type QueryArgs } from '../../useQuery';
import { CurrencyDropdownQueryDocument, type CurrencyDropdownQuery, type CurrencyDropdownQueryVariables } from './CurrencyDropdownQuery';

export async function getCurrencyDropdownQueryClient(variables: CurrencyDropdownQueryVariables) {
  return fetchGraphqlClient<CurrencyDropdownQuery, CurrencyDropdownQueryVariables>(CurrencyDropdownQueryDocument, "CurrencyDropdownQuery", { variables });
}
export const useCurrencyDropdownQuery = (...args: QueryArgs<CurrencyDropdownQueryVariables>) => useQuery<CurrencyDropdownQuery, CurrencyDropdownQueryVariables>(getCurrencyDropdownQueryClient, ...args);